import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Truck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import GestionEntregasEnCamino from '@/pages/laundry/rutas/components/GestionEntregasEnCamino';

const GestionEntregasPage = () => {
  const { idLavanderia } = useParams();

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="p-4 md:p-6 lg:p-8">
      <div className="mb-4">
        <Button asChild variant="outline">
          <Link to={`/centros-lavado/${idLavanderia}`}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Volver al Centro de Lavado
          </Link>
        </Button>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-4">
            <div className="bg-orange-500/10 p-3 rounded-lg">
              <Truck className="h-8 w-8 text-orange-500" />
            </div>
            <div>
              <CardTitle className="text-2xl">Gestión de Entregas En Camino</CardTitle>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <GestionEntregasEnCamino idLavanderia={idLavanderia} />
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default GestionEntregasPage;
